"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Subtract from foundation/Subtract
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const MinusIcon = createSVGIcon(
  <path d="M0 9h18" stroke="currentColor" />,
  "MinusIcon",
  { viewBox: "0 0 18 18", className: legacyIconCls() }
);
